import React from "react";
import AboutSection from "../components/About";

import Footer from "../components/Footer";
import WhyUs from "../components/WhyUs";
import "../css/style.css";
import AboutIntro from "../components/AboutIntro";
function About() {
  return (
    <div className="About-section">
    <AboutIntro />
    <WhyUs />
    <Footer />
    </div>
    
    
  );
}

export default About;
